import { SHARED_LINK_CODE } from '@/assets/dashboard/url-query-params';

export default () => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(SHARED_LINK_CODE);
};
